import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MainNavigationService } from '../main-navigation.service';
import { NGXLogger } from 'ngx-logger';

export interface TeaByRegionResolverData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teaRegion: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teas: any[];
  errors: string[];
}

@Injectable({
  providedIn: 'root'
})
export class TeaByRegionResolver implements Resolve<TeaByRegionResolverData> {
  private mainNavigationService = inject(MainNavigationService);
  private logger = inject(NGXLogger);


  resolve(route: ActivatedRouteSnapshot): Observable<TeaByRegionResolverData> {
    const regionSlug = route.params['tea-region-slug'];
    
    if (!regionSlug) {
      return of({
        teaRegion: null,
        teas: [],
        errors: ['Tea region slug not found in route']
      });
    }

    // Combine both API calls
    return combineLatest([
      this.mainNavigationService.getTeaRegion(regionSlug).pipe(
        catchError(error => {
          this.logger.error('An error occurred while retrieving the tea region:', error);
          return of(null);
        })
      ),
      this.mainNavigationService.getTeasByRegion(regionSlug).pipe(
        catchError(error => {
          this.logger.error('An error occurred while retrieving the teas:', error);
          return of([]);
        })
      )
    ]).pipe(
      map(([teaRegion, teas]) => {
        const errors: string[] = [];
        
        if (!teaRegion) {
          errors.push('An error occurred while retrieving the tea region.');
        }
        
        if (!Array.isArray(teas) || teas.length === 0) {
          // Only add error if we expected teas but got none due to an error
          if (!Array.isArray(teas)) {
            errors.push('An error occurred while retrieving the teas.');
          }
        }

        return {
          teaRegion,
          teas: Array.isArray(teas) ? teas : [],
          errors
        };
      })
    );
  }
}
